import styles from './hastaPublicaResumo.module.scss';
import { useContext, useEffect, useState } from 'react';
import { DiefCfemContext } from './../../../../contexts/DiefCfemContext';
import { IArrematacaoListagemResumo } from './../../../../interfaces/IArrematacao';
import { formatCurrency } from './../../../../utils/formatCurrency';
import InformacaoBasica from '../../../../components/informacaoBasica/informacaoBasica';

import { ArrematacaoTableResumo } from './components/arrematacaoTableResumo/arrematacaoTableResumo';
import { arrematacoesTotais } from '../../../../utils/arrematacoesTotais';

function HastaPublicaResumo() {
  const context = useContext(DiefCfemContext);
  const declaracaoHastaPublica = context?.declaracaoHastaPublica;

  const [arrematacaoListagemData, setArrematacaoListagemData] = useState<IArrematacaoListagemResumo[]>([]);

  useEffect(() => {
    const arrematacoes = declaracaoHastaPublica?.arrematacoes || [];
    const novaListagemData: IArrematacaoListagemResumo[] = arrematacoesTotais(arrematacoes);

    setArrematacaoListagemData(novaListagemData);
  }, [declaracaoHastaPublica]);

  return (
    <div className={styles.container}>
      <h4>Resumo DIEF-CFEM</h4>
      <div className={styles.totais}>
        <InformacaoBasica
          titulo='Valor Total das Arrematações'
          conteudo={formatCurrency(
            arrematacaoListagemData
              ?.reduce((acc, item) => acc + parseFloat(item.totais.valorTotalDeOperacao), 0)
              .toString()
          )}
        />
      </div>
      <>
        <ArrematacaoTableResumo data={arrematacaoListagemData} isLoading={false} />
      </>
    </div>
  );
}

export default HastaPublicaResumo;
